import diamond from 'assets/images/betslip/diamond.gif';
import fire from 'assets/images/betslip/fire.gif';
import { t } from 'i18next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import CouponCounter from 'shared/components/CouponBasketCounter';
import CouponOverviewPanel from 'shared/components/CouponOverviewPanel';
import { AKO, SectionNavigation, SYSTEM } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { BETSType, CookieState, State } from 'shared/interface';
import { addBet, calculateTax } from 'shared/store/coupon.action';
import CouponTypes from '../CouponTypes';
import './styles.scss';

const PrimaryCouponOverviewPanel: React.FC<RouteComponentProps> = () => {
	const bets = useSelector<State, BETSType>((state) => state.coupon.bets);
	const betStats = useSelector<State, any>((state) => state.coupon.betStatics);
	const minOutcomeOddsInfo = betStats?.newPossibleWinning?.totalBonus?.minOutcomeOdds;
	const cookie = useSelector<State, CookieState>((state) => state.cookie);
	const lengthOfBankerBets = bets.outcomes.filter((detail) => detail.banker).length;
	const numOfSlipsWithGroups = bets.outcomes.filter((item) => !item.banker).length + bets.blocks.length;
	const systemBetTemplate = `${bets.betType} z ${numOfSlipsWithGroups} ${lengthOfBankerBets > 0 ? `+ ${lengthOfBankerBets} p` : ''}`;
	const isPrimaryPanelVisible = useSelector<State, boolean>((state) => state.couponOverviewPanel.isPrimaryPanelOverviewPanel);

	const allBets = [...bets.blocks, ...bets.outcomes].flat();
	const isAkoBet = bets.outcomes.filter((item) => item.selectedBet).length > 1;
	const totalOdds = allBets.reduce((acc, item) => acc * item.outcomeOdds, 1);
	const isLiveBet = allBets.some((bet) => bet.isLive);
	const isBetmodeSystem = bets.betMode === SYSTEM;

	const dispatch = useDispatch();
	const { changeNavigationView } = useSectionNavigation();

	const numOfSlipsInBetslip = allBets.length;
	const minAko = bets.outcomes.filter((item) => item.outcomeOdds >= minOutcomeOddsInfo);
	const currentAkoBonusValue = betStats?.newPossibleWinning?.totalBonus?.currentBonusValue;

	useEffect(() => {
		const interval = setInterval(async () => {
			if (numOfSlipsInBetslip > 0 && isLiveBet) {
				dispatch(calculateTax());
			}
		}, 8000);

		if (bets.outcomes.length === 0 && bets.blocks.length === 1 && bets.betMode === SYSTEM) {
			const outcomes = [...bets.blocks.flat(), ...bets.outcomes];
			dispatch(
				addBet({
					...bets,
					blocks: [],
					outcomes,
					betMode: AKO,
				}),
			);
		}

		return () => {
			clearInterval(interval);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numOfSlipsInBetslip]);

	const emojiArray = ['📝', '✌️', '🎶', '🍀'];

	let renderEmoji;
	if (numOfSlipsInBetslip >= 5 && numOfSlipsInBetslip <= 10) {
		renderEmoji = <img src={fire} alt="fire" className="PrimaryCouponOverviewPanel__image" />;
	} else if (numOfSlipsInBetslip >= 11) {
		renderEmoji = <img src={diamond} alt="diamond" className="PrimaryCouponOverviewPanel__image" />;
	} else {
		renderEmoji = emojiArray[numOfSlipsInBetslip - 1];
	}

	return (
		<>
			{isPrimaryPanelVisible && (
				<CouponOverviewPanel
					numOfSlipsInBetslip={numOfSlipsInBetslip}
					onClick={() => changeNavigationView(SectionNavigation.COUPON)}
					cookie={cookie}
					type="primary"
				>
					<CouponTypes
						title={isAkoBet ? t('akoBetType') : t('soloBetType')}
						isAkoBet={isAkoBet}
						renderEmoji={renderEmoji}
						numOfSlipsInBetslip={numOfSlipsInBetslip}
						emojiArray={emojiArray}
						totalOdds={totalOdds}
						isBetmodeSystem={isBetmodeSystem}
						systemBetTemplate={systemBetTemplate}
					/>
					{!isBetmodeSystem && <CouponCounter minAkoOdds={minAko} akoBonusPercent={currentAkoBonusValue} />}
				</CouponOverviewPanel>
			)}
		</>
	);
};

export default withRouter(PrimaryCouponOverviewPanel);
